import React from 'react';
import { NavLink } from 'react-router-dom';
import { MenuItems } from './Slideitems/slide';
import { NewMenuItems } from './Slideitems/slide';
import { Logout } from '../../Services/Logout';
import { FaSignOutAlt } from 'react-icons/fa';


function Menubar(props ) {
  
  return(
    <li className="mm active">
      <NavLink to={props.link}  className="mm active" >
        <div className="menu-icon">
          {props.icon}
        </div>
        <span className="nav-text">{props.label}</span>
      </NavLink>
    </li>
  )
};

const menuItem = MenuItems.map((item) => 
  <Menubar 
    link={item.link}
    label={item.label}
    icon={item.icon} 
  />
)



const SlideBar = () => { 
  const handleLogout = () => {
    // Fonction de traduction simple pour le logout
    const t = (key) => {
      const translations = {
        'textLogin Out': 'Déconnexion en cours...'
      };
      return translations[key] || key;
    };
    
    Logout(t);
  };

  return (
    <>
      {/***sidebarstart*****/}  
      <div className="deznav">
        <div className="deznav-scroll mm-active">
          <ul className="metismenu mm-show" id="menu">
            <li className="menu-title"> Tableau de bord</li>
            {menuItem}
            
            {/* Bouton de déconnexion */}
            <li className="logout-item" style={{ marginTop: 'auto', paddingTop: '20px' }}>
              <button 
                onClick={handleLogout}
                className="logout-btn"
                style={{
                  width: '100%',
                  background: 'none',
                  border: 'none',
                  padding: '10px 20px',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <div className="menu-icon">
                  <FaSignOutAlt />
                </div>
                <span className="nav-text">Déconnexion</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      {/****Sidebar end**/} 
    </>
  )
 
}

export default SlideBar